export const chevronDown = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M4 6L8 10L12 6" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const chevronUp = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M4 10L8 6L12 10" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const calendarIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="currentColor"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M4.83307 2.13332V2.63332H5.33307H10.6664H11.1664V2.13332V1.59998C11.1664 1.5816 11.1813 1.56665 11.1997 1.56665C11.2181 1.56665 11.2331 1.5816 11.2331 1.59998V2.13332V2.63332H11.7331H13.3331C13.9406 2.63332 14.4331 3.12581 14.4331 3.73332V13.3333C14.4331 13.9408 13.9406 14.4333 13.3331 14.4333H2.66641C2.0589 14.4333 1.56641 13.9408 1.56641 13.3333V3.73332C1.56641 3.1258 2.05889 2.63332 2.66641 2.63332H4.26641H4.76641V2.13332V1.59998C4.76641 1.58158 4.78133 1.56665 4.79974 1.56665C4.81815 1.56665 4.83307 1.58158 4.83307 1.59998V2.13332ZM11.1664 3.19998V2.69998H10.6664H5.33307H4.83307V3.19998V3.73332C4.83307 3.75172 4.81815 3.76665 4.79974 3.76665C4.78133 3.76665 4.76641 3.75172 4.76641 3.73332V3.19998V2.69998H4.26641H2.66641C2.09571 2.69998 1.63307 3.16263 1.63307 3.73332V5.33332V5.83332H2.13307H13.8664H14.3664V5.33332V3.73332C14.3664 3.1626 13.9037 2.69998 13.3331 2.69998H11.7331H11.2331V3.19998V3.73332C11.2331 3.7517 11.2181 3.76665 11.1997 3.76665C11.1813 3.76665 11.1664 3.7517 11.1664 3.73332V3.19998ZM2.13307 5.89998H1.63307V6.39998V13.3333C1.63307 13.9039 2.09569 14.3667 2.66641 14.3667H13.3331C13.9037 14.3667 14.3664 13.904 14.3664 13.3333V6.39998V5.89998H13.8664H2.13307ZM7.96641 7.99998C7.96641 7.98158 7.98133 7.96665 7.99974 7.96665C8.01815 7.96665 8.03307 7.98158 8.03307 7.99998C8.03307 8.01839 8.01815 8.03332 7.99974 8.03332C7.98133 8.03332 7.96641 8.01839 7.96641 7.99998ZM10.0997 7.99998C10.0997 7.98158 10.1147 7.96665 10.1331 7.96665C10.1515 7.96665 10.1664 7.98158 10.1664 7.99998C10.1664 8.01839 10.1515 8.03332 10.1331 8.03332C10.1147 8.03332 10.0997 8.01839 10.0997 7.99998ZM12.2331 7.99998C12.2331 7.9816 12.248 7.96665 12.2664 7.96665C12.2848 7.96665 12.2997 7.9816 12.2997 7.99998C12.2997 8.01837 12.2848 8.03332 12.2664 8.03332C12.248 8.03332 12.2331 8.01836 12.2331 7.99998ZM12.2331 10.1333C12.2331 10.1149 12.248 10.1 12.2664 10.1C12.2848 10.1 12.2997 10.1149 12.2997 10.1333C12.2997 10.1517 12.2848 10.1667 12.2664 10.1667C12.248 10.1667 12.2331 10.1517 12.2331 10.1333ZM10.0997 10.1333C10.0997 10.1149 10.1147 10.1 10.1331 10.1C10.1515 10.1 10.1664 10.1149 10.1664 10.1333C10.1664 10.1517 10.1515 10.1667 10.1331 10.1667C10.1147 10.1667 10.0997 10.1517 10.0997 10.1333ZM7.96641 10.1333C7.96641 10.1149 7.98133 10.1 7.99974 10.1C8.01815 10.1 8.03307 10.1149 8.03307 10.1333C8.03307 10.1517 8.01815 10.1667 7.99974 10.1667C7.98133 10.1667 7.96641 10.1517 7.96641 10.1333ZM5.83307 10.1333C5.83307 10.1149 5.848 10.1 5.86641 10.1C5.88481 10.1 5.89974 10.1149 5.89974 10.1333C5.89974 10.1517 5.88481 10.1667 5.86641 10.1667C5.848 10.1667 5.83307 10.1517 5.83307 10.1333ZM3.69974 10.1333C3.69974 10.1149 3.71467 10.1 3.73307 10.1C3.75148 10.1 3.76641 10.1149 3.76641 10.1333C3.76641 10.1517 3.75148 10.1667 3.73307 10.1667C3.71467 10.1667 3.69974 10.1517 3.69974 10.1333ZM3.69974 12.2667C3.69974 12.2483 3.71469 12.2333 3.73307 12.2333C3.75145 12.2333 3.76641 12.2483 3.76641 12.2667C3.76641 12.285 3.75145 12.3 3.73307 12.3C3.71469 12.3 3.69974 12.285 3.69974 12.2667ZM5.83307 12.2667C5.83307 12.2483 5.84803 12.2333 5.86641 12.2333C5.88479 12.2333 5.89974 12.2483 5.89974 12.2667C5.89974 12.285 5.88479 12.3 5.86641 12.3C5.84803 12.3 5.83307 12.285 5.83307 12.2667ZM7.96641 12.2667C7.96641 12.2483 7.98136 12.2333 7.99974 12.2333C8.01812 12.2333 8.03307 12.2483 8.03307 12.2667C8.03307 12.285 8.01812 12.3 7.99974 12.3C7.98136 12.3 7.96641 12.285 7.96641 12.2667ZM10.0997 12.2667C10.0997 12.2483 10.1147 12.2333 10.1331 12.2333C10.1515 12.2333 10.1664 12.2483 10.1664 12.2667C10.1664 12.285 10.1515 12.3 10.1331 12.3C10.1147 12.3 10.0997 12.285 10.0997 12.2667Z" />
	</svg>
);

export const filterIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M14.6668 2H1.3335L6.66683 8.30667V12.6667L9.3335 14V8.30667L14.6668 2Z" stroke="#343941" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
);

export const reloadIcon = (
	<svg 
	width="16"
	height="16" 
	viewBox="0 0 1024 1024"
	stroke="currentColor"
	fill="currentColor">
		<path d="M939.456 256.224c-16.672-5.984-34.976 2.72-40.896 19.36l-24.768 69.344c-28.992-65.312-74.784-122.72-133.088-165.92-185.376-137.28-449.408-99.776-588.384 83.648-67.264 88.768-95.616 198.176-79.84 308.032 15.84 110.304 74.208 207.776 164.352 274.496 75.424 55.808 163.808 82.752 251.456 82.752 128.032 0 254.56-57.44 336.992-166.272 36.48-48.128 61.472-102.08 74.208-160.416 3.776-17.248-7.136-34.304-24.416-38.08-17.216-3.712-34.304 7.104-38.08 24.416-10.784 49.184-31.872 94.752-62.72 135.456-117.888 155.52-341.92 187.232-499.392 70.72-76.288-56.48-125.664-138.912-139.072-232.16-13.344-92.8 10.656-185.248 67.488-260.288 117.856-155.584 341.792-187.424 499.328-70.848 57.024 42.24 99.84 100.608 122.976 166.624l-109.984-42.944c-16.416-6.368-35.008 1.696-41.44 18.176-6.432 16.48 1.728 35.008 18.176 41.44l161.856 63.2c3.808 1.472 7.744 2.208 11.616 2.208 0.544 0 1.024-0.192 1.568-0.224 1.216 0.128 2.432 0.64 3.648 0.64 13.12 0 25.472-8.16 30.112-21.248l57.632-161.184c5.984-16.672-2.688-35.008-19.328-40.928z" /></svg>
);

export const helpIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<g clip-path="url(#clip0_2441_9966)">
			<path d="M6.06016 6.00016C6.2169 5.55461 6.52626 5.1789 6.93347 4.93958C7.34067 4.70027 7.81943 4.61279 8.28495 4.69264C8.75047 4.77249 9.17271 5.01451 9.47688 5.37585C9.78105 5.73718 9.94753 6.19451 9.94683 6.66683C9.94683 8.00016 7.94683 8.66683 7.94683 8.66683M8.00016 11.3335H8.00683M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z"
				strokeLinecap="round"
				strokeLinejoin="round" />
		</g>
		<defs>
			<clipPath id="clip0_2441_9966">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>

	</svg>
);

export const passwordIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<g clip-path="url(#clip0_2797_19292)">
			<path d="M1.33337 11.9998V13.9998C1.33337 14.3998 1.60004 14.6664 2.00004 14.6664H4.66671V12.6664H6.66671V10.6664H8.00004L8.93337 9.73311C9.85993 10.0559 10.8686 10.0546 11.7944 9.72962C12.7201 9.40459 13.5082 8.775 14.0296 7.94386C14.551 7.11272 14.775 6.12923 14.6648 5.15427C14.5546 4.17932 14.1168 3.27062 13.423 2.57683C12.7292 1.88304 11.8205 1.44524 10.8455 1.33504C9.87059 1.22484 8.8871 1.44878 8.05596 1.97021C7.22482 2.49164 6.59523 3.2797 6.27021 4.20546C5.94518 5.13123 5.94394 6.13989 6.26671 7.06645L1.33337 11.9998Z" stroke="#343941" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M11 5.33311C11.1841 5.33311 11.3334 5.18388 11.3334 4.99978C11.3334 4.81569 11.1841 4.66645 11 4.66645C10.8159 4.66645 10.6667 4.81569 10.6667 4.99978C10.6667 5.18388 10.8159 5.33311 11 5.33311Z" strokeLinecap="round" strokeLinejoin="round" />
		</g>
		<defs>
			<clipPath id="clip0_2797_19292">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>

	</svg>
);

export const logOutIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const trashIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M2 4.50016H14M12.6667 4.50016V13.8335C12.6667 14.5002 12 15.1668 11.3333 15.1668H4.66667C4 15.1668 3.33333 14.5002 3.33333 13.8335V4.50016M5.33333 4.50016V3.16683C5.33333 2.50016 6 1.8335 6.66667 1.8335H9.33333C10 1.8335 10.6667 2.50016 10.6667 3.16683V4.50016M6.66667 7.8335V11.8335M9.33333 7.8335V11.8335" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const ImportIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M8 2v7" strokeWidth={1.25}/><path d="m4 6.5 4 4 4-4" strokeWidth={1.25}/>
		<path d="M2.66663 11.1667C2.68504 11.1667 2.69997 11.1816 2.69997 11.2V12.8C2.69997 13.6655 3.39782 14.3667 4.26274 14.3667H11.7346C12.5996 14.3667 13.3 13.6654 13.3 12.8V11.2C13.3 11.1816 13.3149 11.1667 13.3333 11.1667C13.3517 11.1667 13.3666 11.1816 13.3666 11.2V12.8C13.3666 13.702 12.6366 14.4334 11.7346 14.4334H4.26274C3.36068 14.4334 2.6333 13.7021 2.6333 12.8V11.2C2.6333 11.1816 2.64823 11.1667 2.66663 11.1667Z" />
	</svg>
);

export const ExportIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		
		<path d="M8 2v7" strokeWidth={1.25}/>
		<path d="m4 5 4-4 4 4" strokeWidth={1.25}/>
  		<path d="M2.66663 11.1667C2.68504 11.1667 2.69997 11.1816 2.69997 11.2V12.8C2.69997 13.6655 3.39782 14.3667 4.26274 14.3667H11.7346C12.5996 14.3667 13.3 13.6654 13.3 12.8V11.2C13.3 11.1816 13.3149 11.1667 13.3333 11.1667C13.3517 11.1667 13.3666 11.1816 13.3666 11.2V12.8C13.3666 13.702 12.6366 14.4334 11.7346 14.4334H4.26274C3.36068 14.4334 2.6333 13.7021 2.6333 12.8V11.2C2.6333 11.1816 2.64823 11.1667 2.66663 11.1667Z" />
	</svg>
);

export const DragHandleIcon = (
	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M6.56699 4.23333C6.56699 4.61992 6.25359 4.93333 5.86699 4.93333C5.48039 4.93333 5.16699 4.61992 5.16699 4.23333C5.16699 3.84673 5.48039 3.53333 5.86699 3.53333C6.25359 3.53333 6.56699 3.84673 6.56699 4.23333ZM10.8337 4.23333C10.8337 4.61992 10.5202 4.93333 10.1337 4.93333C9.74706 4.93333 9.43366 4.61992 9.43366 4.23333C9.43366 3.84673 9.74706 3.53333 10.1337 3.53333C10.5202 3.53333 10.8337 3.84673 10.8337 4.23333ZM10.8337 8.49999C10.8337 8.88659 10.5202 9.19999 10.1337 9.19999C9.74706 9.19999 9.43366 8.88659 9.43366 8.49999C9.43366 8.11339 9.74706 7.79999 10.1337 7.79999C10.5202 7.79999 10.8337 8.1134 10.8337 8.49999ZM6.56699 8.49999C6.56699 8.88659 6.25359 9.19999 5.86699 9.19999C5.48039 9.19999 5.16699 8.88659 5.16699 8.49999C5.16699 8.11339 5.48039 7.79999 5.86699 7.79999C6.25359 7.79999 6.56699 8.11339 6.56699 8.49999ZM10.8337 12.7667C10.8337 13.1532 10.5202 13.4667 10.1337 13.4667C9.74707 13.4667 9.43366 13.1532 9.43366 12.7667C9.43366 12.3801 9.74707 12.0667 10.1337 12.0667C10.5202 12.0667 10.8337 12.3801 10.8337 12.7667ZM6.56699 12.7667C6.56699 13.1532 6.25358 13.4667 5.86699 13.4667C5.4804 13.4667 5.16699 13.1532 5.16699 12.7667C5.16699 12.3801 5.4804 12.0667 5.86699 12.0667C6.25359 12.0667 6.56699 12.3801 6.56699 12.7667Z" fill="#343941" stroke="#343941"/>	</svg>
);

export const infoIcon = (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<g clip-path="url(#clip0_3340_5454)">
    <path d="M6 8V6M6 4H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_3340_5454">
      <rect width="12" height="12" fill="white"/>
    </clipPath>
  </defs>
	</svg>
);

export const CheckAvailabilityicon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
  		<path d="M2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.67737 2.00631 11.2874 2.66082 12.4933 3.82667L14 5.33333M14 5.33333V2M14 5.33333H10.6667M14 8C14 9.5913 13.3679 11.1174 12.2426 12.2426C11.1174 13.3679 9.5913 14 8 14C6.32263 13.9937 4.71265 13.3392 3.50667 12.1733L2 10.6667M2 10.6667H5.33333M2 10.6667V14" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const checkIcon = (
	<svg
		width="12"
		height="12"
		viewBox="0 0 100 100"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
  		<path d="M20 50 L40 70 L80 30" stroke-width="10" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
);

export const RunningIcon = (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
			<g clip-path="url(#clip0_3294_3338)">
				<mask id="path-1-inside-1_3294_3338" fill="white">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M1.52237 5.837C1.52237 8.27238 3.28813 9.93134 5.27095 10.2747C5.49784 10.314 5.64993 10.5297 5.61064 10.7567C5.57136 10.9836 5.35557 11.1357 5.12868 11.0964C2.79934 10.693 0.688477 8.72974 0.688477 5.837C0.688476 4.60765 1.24777 3.64154 1.90092 2.9066C2.3688 2.38012 2.90408 1.95266 3.33457 1.6252H2.02544C1.80453 1.6252 1.62544 1.44611 1.62544 1.2252C1.62544 1.00428 1.80453 0.825195 2.02544 0.825195H4.42544C4.64636 0.825195 4.82544 1.00428 4.82544 1.2252V3.6252C4.82544 3.84611 4.64636 4.0252 4.42544 4.0252C4.20453 4.0252 4.02544 3.84611 4.02544 3.6252V2.14874L4.02424 2.14965C3.56706 2.49446 3.00828 2.91588 2.52424 3.46054C1.95262 4.10375 1.52237 4.88081 1.52237 5.837ZM10.4085 6.16215C10.4085 3.7525 8.6802 2.10326 6.72288 1.73581C6.49655 1.69332 6.34752 1.47541 6.39001 1.24908C6.4325 1.02276 6.65041 0.873739 6.87673 0.916227C9.17612 1.34791 11.2424 3.30042 11.2424 6.16215C11.2424 7.39148 10.6831 8.35758 10.03 9.09254C9.56204 9.61902 9.02676 10.0465 8.59628 10.374H9.90548C10.1264 10.374 10.3055 10.553 10.3055 10.774C10.3055 10.9949 10.1264 11.174 9.90548 11.174H7.50544C7.28453 11.174 7.10544 10.9949 7.10544 10.774V8.37398C7.10544 8.15302 7.28453 7.97395 7.50544 7.97395C7.72636 7.97395 7.90544 8.15302 7.90544 8.37398V9.85038L7.9067 9.84942C8.36388 9.50462 8.9226 9.08326 9.4066 8.53862C9.97828 7.89539 10.4085 7.11833 10.4085 6.16215Z"/>
				</mask>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M1.52237 5.837C1.52237 8.27238 3.28813 9.93134 5.27095 10.2747C5.49784 10.314 5.64993 10.5297 5.61064 10.7567C5.57136 10.9836 5.35557 11.1357 5.12868 11.0964C2.79934 10.693 0.688477 8.72974 0.688477 5.837C0.688476 4.60765 1.24777 3.64154 1.90092 2.9066C2.3688 2.38012 2.90408 1.95266 3.33457 1.6252H2.02544C1.80453 1.6252 1.62544 1.44611 1.62544 1.2252C1.62544 1.00428 1.80453 0.825195 2.02544 0.825195H4.42544C4.64636 0.825195 4.82544 1.00428 4.82544 1.2252V3.6252C4.82544 3.84611 4.64636 4.0252 4.42544 4.0252C4.20453 4.0252 4.02544 3.84611 4.02544 3.6252V2.14874L4.02424 2.14965C3.56706 2.49446 3.00828 2.91588 2.52424 3.46054C1.95262 4.10375 1.52237 4.88081 1.52237 5.837ZM10.4085 6.16215C10.4085 3.7525 8.6802 2.10326 6.72288 1.73581C6.49655 1.69332 6.34752 1.47541 6.39001 1.24908C6.4325 1.02276 6.65041 0.873739 6.87673 0.916227C9.17612 1.34791 11.2424 3.30042 11.2424 6.16215C11.2424 7.39148 10.6831 8.35758 10.03 9.09254C9.56204 9.61902 9.02676 10.0465 8.59628 10.374H9.90548C10.1264 10.374 10.3055 10.553 10.3055 10.774C10.3055 10.9949 10.1264 11.174 9.90548 11.174H7.50544C7.28453 11.174 7.10544 10.9949 7.10544 10.774V8.37398C7.10544 8.15302 7.28453 7.97395 7.50544 7.97395C7.72636 7.97395 7.90544 8.15302 7.90544 8.37398V9.85038L7.9067 9.84942C8.36388 9.50462 8.9226 9.08326 9.4066 8.53862C9.97828 7.89539 10.4085 7.11833 10.4085 6.16215Z" fill="#343941"/>
				<path d="M5.27095 10.2747L5.10032 11.26L5.10037 11.26L5.27095 10.2747ZM5.61064 10.7567L6.59598 10.9273L6.59599 10.9273L5.61064 10.7567ZM5.12868 11.0964L4.95805 12.0817L4.9581 12.0817L5.12868 11.0964ZM0.688477 5.837L1.68848 5.837L1.68848 5.837L0.688477 5.837ZM1.90092 2.9066L1.15344 2.24231L1.15344 2.24231L1.90092 2.9066ZM3.33457 1.6252L3.93999 2.4211L6.30096 0.625195H3.33457V1.6252ZM4.02544 2.14874H5.02544V0.141029L3.42299 1.35059L4.02544 2.14874ZM4.02424 2.14965L4.62639 2.94803L4.62669 2.9478L4.02424 2.14965ZM2.52424 3.46054L1.77676 2.79625L1.77676 2.79626L2.52424 3.46054ZM6.72288 1.73581L6.90738 0.75298L6.90738 0.75298L6.72288 1.73581ZM6.39001 1.24908L5.40718 1.06457L5.40718 1.06458L6.39001 1.24908ZM6.87673 0.916227L7.06125 -0.0666027L7.06124 -0.0666031L6.87673 0.916227ZM10.03 9.09254L10.7774 9.75686L10.7775 9.7568L10.03 9.09254ZM8.59628 10.374L7.99079 9.57814L5.63039 11.374H8.59628V10.374ZM7.90544 9.85038H6.90544V11.8735L8.51275 10.6448L7.90544 9.85038ZM7.9067 9.84942L7.30455 9.05101L7.29939 9.05495L7.9067 9.84942ZM9.4066 8.53862L8.65915 7.87431L8.65911 7.87435L9.4066 8.53862ZM0.522373 5.837C0.522373 8.81959 2.70064 10.8445 5.10032 11.26L5.44158 9.28936C3.87563 9.01819 2.52237 7.72517 2.52237 5.837H0.522373ZM5.10037 11.26C4.783 11.2051 4.5704 10.9033 4.6253 10.5861L6.59599 10.9273C6.72947 10.1562 6.21269 9.42286 5.44153 9.28936L5.10037 11.26ZM4.62531 10.5861C4.68026 10.2687 4.98204 10.0561 5.29926 10.111L4.9581 12.0817C5.72911 12.2152 6.46245 11.6984 6.59598 10.9273L4.62531 10.5861ZM5.2993 10.111C3.38435 9.77944 1.68848 8.18022 1.68848 5.837H-0.311523C-0.311523 9.27926 2.21434 11.6066 4.95805 12.0817L5.2993 10.111ZM1.68848 5.837C1.68848 4.93547 2.09278 4.19608 2.6484 3.57088L1.15344 2.24231C0.402762 3.087 -0.311524 4.27984 -0.311523 5.837L1.68848 5.837ZM2.64839 3.57088C3.04922 3.11986 3.5206 2.74012 3.93999 2.4211L2.72915 0.829289C2.28755 1.1652 1.68837 1.64039 1.15344 2.24231L2.64839 3.57088ZM3.33457 0.625195H2.02544V2.6252H3.33457V0.625195ZM2.02544 0.625195C2.35682 0.625195 2.62544 0.893823 2.62544 1.2252H0.625445C0.625445 1.99839 1.25225 2.6252 2.02544 2.6252V0.625195ZM2.62544 1.2252C2.62544 1.55657 2.35682 1.8252 2.02544 1.8252V-0.174805C1.25225 -0.174805 0.625445 0.451999 0.625445 1.2252H2.62544ZM2.02544 1.8252H4.42544V-0.174805H2.02544V1.8252ZM4.42544 1.8252C4.09407 1.8252 3.82544 1.55657 3.82544 1.2252H5.82544C5.82544 0.451999 5.19864 -0.174805 4.42544 -0.174805V1.8252ZM3.82544 1.2252V3.6252H5.82544V1.2252H3.82544ZM3.82544 3.6252C3.82544 3.29382 4.09407 3.0252 4.42544 3.0252V5.0252C5.19864 5.0252 5.82544 4.39839 5.82544 3.6252H3.82544ZM4.42544 3.0252C4.75682 3.0252 5.02544 3.29382 5.02544 3.6252H3.02544C3.02544 4.39839 3.65225 5.0252 4.42544 5.0252V3.0252ZM5.02544 3.6252V2.14874H3.02544V3.6252H5.02544ZM3.42299 1.35059L3.42178 1.3515L4.62669 2.9478L4.6279 2.94689L3.42299 1.35059ZM3.42209 1.35127C2.97231 1.69049 2.33602 2.16696 1.77676 2.79625L3.27171 4.12483C3.68054 3.66481 4.16181 3.29843 4.62639 2.94803L3.42209 1.35127ZM1.77676 2.79626C1.10709 3.54979 0.522373 4.55355 0.522373 5.837H2.52237C2.52237 5.20807 2.79815 4.6577 3.27172 4.12482L1.77676 2.79626ZM11.4085 6.16215C11.4085 3.21158 9.27627 1.19769 6.90738 0.75298L6.53837 2.71864C8.08414 3.00883 9.40852 4.29342 9.40852 6.16215H11.4085ZM6.90738 0.75298C7.22387 0.812393 7.43225 1.11713 7.37284 1.43359L5.40718 1.06458C5.2628 1.8337 5.76923 2.57425 6.53837 2.71864L6.90738 0.75298ZM7.37284 1.43359C7.31343 1.75008 7.0087 1.95847 6.69222 1.89906L7.06124 -0.0666031C6.29213 -0.210993 5.55157 0.295446 5.40718 1.06457L7.37284 1.43359ZM6.69222 1.89906C8.58244 2.25392 10.2424 3.84356 10.2424 6.16215H12.2424C12.2424 2.75728 9.76981 0.441894 7.06125 -0.0666027L6.69222 1.89906ZM10.2424 6.16215C10.2424 7.06367 9.83807 7.80305 9.28247 8.42828L10.7775 9.7568C11.5281 8.91211 12.2424 7.71929 12.2424 6.16215H10.2424ZM9.28251 8.42823C8.88163 8.87927 8.41025 9.259 7.99079 9.57814L9.20178 11.1698C9.64328 10.8339 10.2425 10.3588 10.7774 9.75686L9.28251 8.42823ZM8.59628 11.374H9.90548V9.37398H8.59628V11.374ZM9.90548 11.374C9.57421 11.374 9.30548 11.1054 9.30548 10.774H11.3055C11.3055 10.0006 10.6785 9.37398 9.90548 9.37398V11.374ZM9.30548 10.774C9.30548 10.4426 9.57408 10.174 9.90548 10.174V12.174C10.6786 12.174 11.3055 11.5471 11.3055 10.774H9.30548ZM9.90548 10.174H7.50544V12.174H9.90548V10.174ZM7.50544 10.174C7.83687 10.174 8.10544 10.4426 8.10544 10.774H6.10544C6.10544 11.5471 6.7322 12.174 7.50544 12.174V10.174ZM8.10544 10.774V8.37398H6.10544V10.774H8.10544ZM8.10544 8.37398C8.10544 8.70528 7.83684 8.97395 7.50544 8.97395V6.97395C6.73222 6.97395 6.10544 7.60076 6.10544 8.37398H8.10544ZM7.50544 8.97395C7.17405 8.97395 6.90544 8.70528 6.90544 8.37398H8.90544C8.90544 7.60076 8.27867 6.97395 7.50544 6.97395V8.97395ZM6.90544 8.37398V9.85038H8.90544V8.37398H6.90544ZM8.51275 10.6448L8.51401 10.6439L7.29939 9.05495L7.29814 9.05591L8.51275 10.6448ZM8.50884 10.6478C8.95862 10.3086 9.59487 9.83219 10.1541 9.20289L8.65911 7.87435C8.25034 8.33434 7.76915 8.70064 7.30457 9.05103L8.50884 10.6478ZM10.1541 9.20293C10.8238 8.44936 11.4085 7.44559 11.4085 6.16215H9.40852C9.40852 6.79107 9.13276 7.34142 8.65915 7.87431L10.1541 9.20293Z" fill="#343941" mask="url(#path-1-inside-1_3294_3338)"/>
			</g>
			<defs>
				<clipPath id="clip0_3294_3338">
				<rect width="12" height="12" fill="white"/>
				</clipPath>
			</defs>
</svg>
);


export const AddUserIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
  		<path d="M10.6663 14V12.6667C10.6663 11.9594 10.3854 11.2811 9.88529 10.781C9.3852 10.281 8.70692 10 7.99967 10H3.99967C3.29243 10 2.61415 10.281 2.11406 10.781C1.61396 11.2811 1.33301 11.9594 1.33301 12.6667V14M12.6663 5.33333V9.33333M14.6663 7.33333H10.6663M8.66634 4.66667C8.66634 6.13943 7.47243 7.33333 5.99967 7.33333C4.52691 7.33333 3.33301 6.13943 3.33301 4.66667C3.33301 3.19391 4.52691 2 5.99967 2C7.47243 2 8.66634 3.19391 8.66634 4.66667Z" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
);

export const DocumentsIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
  		<path d="M13.3005 6.40023V5.90023H12.8005H9.06712C9.04872 5.90023 9.03379 5.8853 9.03379 5.86689V2.13356V1.63356H8.53379H3.73379C3.1631 1.63356 2.70046 2.0962 2.70046 2.66689V13.3336C2.70046 13.9042 3.16307 14.3669 3.73379 14.3669H12.2671C12.8378 14.3669 13.3005 13.9042 13.3005 13.3336V6.40023ZM9.95401 2.53426L9.10046 1.68071V2.88781V5.33356V5.83356H9.60046H12.0462H13.2533L12.3998 4.98001L9.95401 2.53426ZM9.09067 1.57664L9.09069 1.57666L13.3573 5.84321C13.3636 5.84953 13.3671 5.85808 13.3671 5.86689V13.3336C13.3671 13.941 12.8746 14.4336 12.2671 14.4336H3.73379C3.12628 14.4336 2.63379 13.9411 2.63379 13.3336V2.66689C2.63379 2.05938 3.12627 1.56689 3.73379 1.56689H9.06712C9.07597 1.56689 9.08444 1.57041 9.09067 1.57664Z" />
	</svg>
);

export const EmailIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
  		<path d="M14.6663 4.6665L8.68634 8.4665C8.48052 8.59545 8.24255 8.66384 7.99967 8.66384C7.7568 8.66384 7.51883 8.59545 7.31301 8.4665L1.33301 4.6665M2.66634 2.6665H13.333C14.0694 2.6665 14.6663 3.26346 14.6663 3.99984V11.9998C14.6663 12.7362 14.0694 13.3332 13.333 13.3332H2.66634C1.92996 13.3332 1.33301 12.7362 1.33301 11.9998V3.99984C1.33301 3.26346 1.92996 2.6665 2.66634 2.6665Z" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const DeleteOrderIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<g clip-path="url(#clip0_2983_15092)">
			<path d="M9.99967 6.00016L5.99967 10.0002M5.99967 6.00016L9.99967 10.0002M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z" strokeLinecap="round" strokeLinejoin="round"/>
		</g>
		<defs>
			<clipPath id="clip0_2983_15092">
			<rect width="16" height="16" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

export const EditIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
  		<g clip-path="url(#clip0_2983_17992)">
			<path d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z" strokeLinecap="round" strokeLinejoin="round"/>
		</g>
		<defs>
			<clipPath id="clip0_2983_17992">
			<rect width="16" height="16" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

export const cartIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<g clip-path="url(#clip0_2455_7270)">
			<path d="M1.3667 1.3667H2.70003L4.47337 9.6467C4.53842 9.94994 4.70715 10.221 4.95051 10.4133C5.19387 10.6055 5.49664 10.7069 5.8067 10.7H12.3267C12.6301 10.6995 12.9244 10.5956 13.1607 10.4053C13.3971 10.215 13.5615 9.94972 13.6267 9.65336L14.7267 4.70003H3.41337M6.00003 14C6.00003 14.3682 5.70156 14.6667 5.33337 14.6667C4.96518 14.6667 4.6667 14.3682 4.6667 14C4.6667 13.6318 4.96518 13.3334 5.33337 13.3334C5.70156 13.3334 6.00003 13.6318 6.00003 14ZM13.3334 14C13.3334 14.3682 13.0349 14.6667 12.6667 14.6667C12.2985 14.6667 12 14.3682 12 14C12 13.6318 12.2985 13.3334 12.6667 13.3334C13.0349 13.3334 13.3334 13.6318 13.3334 14Z"
				strokeLinecap="round"
				strokeLinejoin="round" />
		</g>
		<defs>
			<clipPath id="clip0_2455_7270">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const userIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M12.6668 14V12.6667C12.6668 11.9594 12.3859 11.2811 11.8858 10.781C11.3857 10.281 10.7074 10 10.0002 10H6.00016C5.29292 10 4.61464 10.281 4.11454 10.781C3.61445 11.2811 3.3335 11.9594 3.3335 12.6667V14M10.6668 4.66667C10.6668 6.13943 9.47292 7.33333 8.00016 7.33333C6.5274 7.33333 5.3335 6.13943 5.3335 4.66667C5.3335 3.19391 6.5274 2 8.00016 2C9.47292 2 10.6668 3.19391 10.6668 4.66667Z"
			strokeLinecap="round"
			strokeLinejoin="round" />
	</svg>
);

export const searchIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M14 14L11.1333 11.1333M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
			strokeLinecap="round"
			strokeLinejoin="round" />
	</svg>
);

export const magnifyIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M14 14L11.1 11.1M7.33333 5.33333V9.33333M5.33333 7.33333H9.33333M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);


export const sortIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<g id="caret-sort">

			<path d="M5 5.5L8 2.5L11 5.5" />

			<path d="M5 10.5l3 3l3-3" />
		</g>
	</svg>
);

export const sortIconDown = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<g id="caret-sort">
			<path d="M4 6L8 10L12 6" strokeLinecap="round" strokeLinejoin="round"  stroke="#00703D"/>
		</g>
	</svg>
);

export const sortIconUp = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<g id="caret-sort">
			<path d="M4 10L8 6L12 10" strokeLinecap="round" strokeLinejoin="round" stroke="#00703D" />
		</g>
	</svg>
);

export const arrowIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M3.33301 8.00016H12.6663M12.6663 8.00016L7.99967 3.3335M12.6663 8.00016L7.99967 12.6668"
			strokeLinecap="round"
			strokeLinejoin="round" />
	</svg>
);

export const arrowLeftIcon = (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M10.0003 15.8337L4.16699 10.0003M4.16699 10.0003L10.0003 4.16699M4.16699 10.0003H15.8337" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
);

export const arrowRightIcon = (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M4.16699 10.0003H15.8337M15.8337 10.0003L10.0003 4.16699M15.8337 10.0003L10.0003 15.8337" stroke="#343941" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
);

export const ErrorIcon = (
	<svg
		width="12" height="12" viewBox="0 0 12 12"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
		strokeWidth={0.3}
	>
		<mask id="path-1-inside-1_3294_9333" fill="white">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75582 0.487085C6.41454 -0.0855389 5.58526 -0.0855389 5.24397 0.487086L0.128845 9.06951C-0.220757 9.65607 0.201905 10.4001 0.884766 10.4001H11.115C11.7979 10.4001 12.2205 9.65607 11.8709 9.06951L6.75582 0.487085ZM5.93118 0.896657C5.96221 0.844601 6.0376 0.844601 6.06862 0.896657L11.1837 9.47911C11.2156 9.53239 11.1771 9.60007 11.115 9.60007H0.884766C0.822694 9.60007 0.784265 9.53239 0.816046 9.47911L5.93118 0.896657ZM5.46142 3.58896C5.44967 3.28346 5.69417 3.02938 5.9999 3.02938C6.30564 3.02938 6.55013 3.28346 6.53838 3.58897L6.41527 6.78968C6.40669 7.01287 6.22326 7.18939 5.9999 7.18939C5.77654 7.18939 5.59311 7.01287 5.58453 6.78968L5.46142 3.58896ZM6.59981 8.38087C6.59981 8.71223 6.33118 8.98087 5.99981 8.98087C5.66844 8.98087 5.39981 8.71223 5.39981 8.38087C5.39981 8.04951 5.66844 7.78087 5.99981 7.78087C6.33118 7.78087 6.59981 8.04951 6.59981 8.38087Z"/>
  </mask>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75582 0.487085C6.41454 -0.0855389 5.58526 -0.0855389 5.24397 0.487086L0.128845 9.06951C-0.220757 9.65607 0.201905 10.4001 0.884766 10.4001H11.115C11.7979 10.4001 12.2205 9.65607 11.8709 9.06951L6.75582 0.487085ZM5.93118 0.896657C5.96221 0.844601 6.0376 0.844601 6.06862 0.896657L11.1837 9.47911C11.2156 9.53239 11.1771 9.60007 11.115 9.60007H0.884766C0.822694 9.60007 0.784265 9.53239 0.816046 9.47911L5.93118 0.896657ZM5.46142 3.58896C5.44967 3.28346 5.69417 3.02938 5.9999 3.02938C6.30564 3.02938 6.55013 3.28346 6.53838 3.58897L6.41527 6.78968C6.40669 7.01287 6.22326 7.18939 5.9999 7.18939C5.77654 7.18939 5.59311 7.01287 5.58453 6.78968L5.46142 3.58896ZM6.59981 8.38087C6.59981 8.71223 6.33118 8.98087 5.99981 8.98087C5.66844 8.98087 5.39981 8.71223 5.39981 8.38087C5.39981 8.04951 5.66844 7.78087 5.99981 7.78087C6.33118 7.78087 6.59981 8.04951 6.59981 8.38087Z" fill="#343941"/>
  <path d="M6.75582 0.487085L5.89681 0.999048L5.89682 0.999052L6.75582 0.487085ZM5.24397 0.487086L4.38497 -0.0248851L4.38497 -0.0248813L5.24397 0.487086ZM0.128845 9.06951L0.987842 9.58149L0.98785 9.58148L0.128845 9.06951ZM11.8709 9.06951L11.0119 9.58148L11.0119 9.58149L11.8709 9.06951ZM5.93118 0.896657L6.79019 1.40862L6.7902 1.40861L5.93118 0.896657ZM6.06862 0.896657L5.20961 1.40861L5.20962 1.40862L6.06862 0.896657ZM11.1837 9.47911L10.3247 9.99108L10.3253 9.99209L11.1837 9.47911ZM0.816046 9.47911L1.67487 9.99139L1.67505 9.99108L0.816046 9.47911ZM5.46142 3.58896L6.46068 3.55053L6.46068 3.55052L5.46142 3.58896ZM6.53838 3.58897L7.53764 3.62741L7.53764 3.62738L6.53838 3.58897ZM6.41527 6.78968L5.41601 6.75125L5.41601 6.75125L6.41527 6.78968ZM5.58453 6.78968L6.58379 6.75125L6.58379 6.75125L5.58453 6.78968ZM7.61483 -0.0248775C6.88572 -1.24823 5.11408 -1.24821 4.38497 -0.0248851L6.10298 0.999057C6.05645 1.07713 5.94336 1.07715 5.89681 0.999048L7.61483 -0.0248775ZM4.38497 -0.0248813L-0.73016 8.55755L0.98785 9.58148L6.10298 0.999053L4.38497 -0.0248813ZM-0.730153 8.55753C-1.47703 9.81064 -0.574113 11.4001 0.884766 11.4001V9.40007C0.900022 9.40007 0.92441 9.40534 0.94777 9.4195C0.968424 9.43202 0.98135 9.44712 0.989114 9.46079C0.996878 9.47446 1.00323 9.49329 1.00341 9.51744C1.00362 9.54474 0.995655 9.56839 0.987842 9.58149L-0.730153 8.55753ZM0.884766 11.4001H11.115V9.40007H0.884766V11.4001ZM11.115 11.4001C12.5739 11.4001 13.4768 9.81062 12.7299 8.55754L11.0119 9.58149C11.0041 9.56839 10.9962 9.54475 10.9964 9.51745C10.9966 9.4933 11.0029 9.47447 11.0107 9.4608C11.0184 9.44713 11.0314 9.43202 11.052 9.4195C11.0754 9.40534 11.0998 9.40007 11.115 9.40007V11.4001ZM12.7299 8.55755L7.61483 -0.0248814L5.89682 0.999052L11.0119 9.58148L12.7299 8.55755ZM6.7902 1.40861C6.4334 2.00728 5.5664 2.00728 5.20961 1.40861L6.92764 0.384707C6.50879 -0.318082 5.49101 -0.318082 5.07217 0.384707L6.7902 1.40861ZM5.20962 1.40862L10.3247 9.99108L12.0427 8.96715L6.92763 0.384692L5.20962 1.40862ZM10.3253 9.99209C9.95789 9.37721 10.4025 8.60007 11.115 8.60007V10.6001C11.9517 10.6001 12.4733 9.68758 12.0421 8.96614L10.3253 9.99209ZM11.115 8.60007H0.884766V10.6001H11.115V8.60007ZM0.884766 8.60007C1.59862 8.60007 2.04079 9.37792 1.67487 9.99139L-0.0427751 8.96684C-0.472263 9.68687 0.0467709 10.6001 0.884766 10.6001V8.60007ZM1.67505 9.99108L6.79019 1.40862L5.07218 0.384691L-0.0429592 8.96715L1.67505 9.99108ZM6.46068 3.55052C6.47074 3.81197 6.26152 4.02938 5.9999 4.02938V2.02938C5.12682 2.02938 4.4286 2.75494 4.46216 3.6274L6.46068 3.55052ZM5.9999 4.02938C5.73826 4.02938 5.52907 3.81194 5.53912 3.55056L7.53764 3.62738C7.57118 2.75497 6.87302 2.02938 5.9999 2.02938V4.02938ZM5.53912 3.55053L5.41601 6.75125L7.41453 6.82812L7.53764 3.62741L5.53912 3.55053ZM5.41601 6.75125C5.42808 6.43753 5.68591 6.18939 5.9999 6.18939V8.18939C6.76061 8.18939 7.3853 7.58822 7.41453 6.82811L5.41601 6.75125ZM5.9999 6.18939C6.31387 6.18939 6.57172 6.4375 6.58379 6.75125L4.58527 6.82811C4.6145 7.58825 5.23922 8.18939 5.9999 8.18939V6.18939ZM6.58379 6.75125L6.46068 3.55053L4.46216 3.62739L4.58527 6.82811L6.58379 6.75125ZM5.59981 8.38087C5.59981 8.15996 5.77889 7.98087 5.99981 7.98087V9.98087C6.88347 9.98087 7.59981 9.26451 7.59981 8.38087H5.59981ZM5.99981 7.98087C6.22074 7.98087 6.39981 8.15997 6.39981 8.38087H4.39981C4.39981 9.2645 5.11614 9.98087 5.99981 9.98087V7.98087ZM6.39981 8.38087C6.39981 8.60176 6.22076 8.78087 5.99981 8.78087V6.78087C5.11612 6.78087 4.39981 7.49726 4.39981 8.38087H6.39981ZM5.99981 8.78087C5.77887 8.78087 5.59981 8.60177 5.59981 8.38087H7.59981C7.59981 7.49725 6.88349 6.78087 5.99981 6.78087V8.78087Z" fill="#343941" mask="url(#path-1-inside-1_3294_9333)"/>
</svg>
);

export const checkCircle = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 20 20"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M18.8332 9.23355V10.0002C18.8321 11.7972 18.2503 13.5458 17.1743 14.9851C16.0983 16.4244 14.5859 17.4773 12.8626 17.9868C11.1394 18.4963 9.29755 18.4351 7.6119 17.8124C5.92624 17.1896 4.48705 16.0386 3.50897 14.5311C2.53089 13.0236 2.06633 11.2403 2.18457 9.44714C2.30281 7.65402 2.99751 5.94715 4.16507 4.58111C5.33263 3.21506 6.91049 2.26303 8.66333 1.867C10.4162 1.47097 12.2501 1.65216 13.8915 2.38355M18.8332 3.33355L10.4998 11.6752L7.99984 9.17521"
			strokeLinecap="round"
			strokeLinejoin="round" />
	</svg>
);

export const cornerDownLeftIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M5.99984 6.66675L2.6665 10.0001M2.6665 10.0001L5.99984 13.3334M2.6665 10.0001H10.6665C11.3737 10.0001 12.052 9.71913 12.5521 9.21903C13.0522 8.71894 13.3332 8.04066 13.3332 7.33341V2.66675"
			strokeLinecap="round"
			strokeLinejoin="round" />
	</svg>
);

<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_2983_13067)">
    <path d="M1.3667 1.36664H2.70003L4.47337 9.64664C4.53842 9.94988 4.70715 10.221 4.95051 10.4132C5.19387 10.6055 5.49664 10.7069 5.8067 10.7H12.3267C12.6301 10.6995 12.9244 10.5955 13.1607 10.4052C13.3971 10.2149 13.5615 9.94966 13.6267 9.6533L14.7267 4.69997H3.41337M6.00003 14C6.00003 14.3682 5.70156 14.6666 5.33337 14.6666C4.96518 14.6666 4.6667 14.3682 4.6667 14C4.6667 13.6318 4.96518 13.3333 5.33337 13.3333C5.70156 13.3333 6.00003 13.6318 6.00003 14ZM13.3334 14C13.3334 14.3682 13.0349 14.6666 12.6667 14.6666C12.2985 14.6666 12 14.3682 12 14C12 13.6318 12.2985 13.3333 12.6667 13.3333C13.0349 13.3333 13.3334 13.6318 13.3334 14Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_2983_13067">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>

export const configureIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M2.63307 11.6422V11.2886L2.29968 11.1708C1.87177 11.0196 1.56641 10.6115 1.56641 10.1333V3.7333C1.56641 3.12578 2.05889 2.6333 2.66641 2.6333H13.3331C13.9406 2.6333 14.4331 3.12579 14.4331 3.7333V10.1333C14.4331 10.6115 14.1277 11.0196 13.6998 11.1708L13.3664 11.2886V11.6422V12.2666C13.3664 12.8741 12.8739 13.3666 12.2664 13.3666H3.73307C3.12556 13.3666 2.63307 12.8741 2.63307 12.2666V11.6422ZM13.2997 11.7333V11.2333H12.7997H3.19974H2.69974V11.7333V12.2666C2.69974 12.8373 3.16236 13.3 3.73307 13.3H12.2664C12.8371 13.3 13.2997 12.8373 13.2997 12.2666V11.7333ZM7.46641 6.89997H7.96641V6.39997V4.79997C7.96641 4.78156 7.98133 4.76663 7.99974 4.76663C8.01815 4.76663 8.03307 4.78156 8.03307 4.79997V6.39997V6.89997H8.53307H10.1331C10.1515 6.89997 10.1664 6.91489 10.1664 6.9333C10.1664 6.95171 10.1515 6.96663 10.1331 6.96663H8.53307H8.03307V7.46663V9.06663C8.03307 9.08504 8.01815 9.09997 7.99974 9.09997C7.98133 9.09997 7.96641 9.08504 7.96641 9.06663V7.46663V6.96663H7.46641H5.86641C5.848 6.96663 5.83307 6.95171 5.83307 6.9333C5.83307 6.91489 5.848 6.89997 5.86641 6.89997H7.46641ZM2.66641 2.69997C2.09571 2.69997 1.63307 3.16261 1.63307 3.7333V10.1333C1.63307 10.704 2.09571 11.1666 2.66641 11.1666H13.3331C13.9037 11.1666 14.3664 10.704 14.3664 10.1333V3.7333C14.3664 3.16258 13.9037 2.69997 13.3331 2.69997H2.66641Z"
			strokeLinecap="round"
			strokeLinejoin="round" />
	</svg>
);

export const switchUncheckedIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M12 4L4 12M4 4L12 12" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
);

export const switchCheckedIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
	>
  <path d="M7.47192 11.5575L7.47191 11.5575C7.44528 11.5983 7.40206 11.6254 7.35346 11.6316C7.30517 11.6378 7.25649 11.6225 7.22031 11.5896C7.2203 11.5896 7.22029 11.5896 7.22028 11.5896L4.28698 8.92294C4.21887 8.86103 4.21385 8.75562 4.27577 8.68751C4.33769 8.61939 4.44309 8.61438 4.51119 8.67629L4.5112 8.6763L6.866 10.817L7.2999 11.2115L7.62082 10.7207L11.7263 4.44175C11.7767 4.3647 11.8799 4.34309 11.957 4.39346C12.034 4.44386 12.0556 4.54716 12.0053 4.62415L12.4238 4.89778L12.0053 4.62416L7.47192 11.5575Z" stroke="#00703D"/>
	</svg>
);

export const facebookIcon = (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="currentColor"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M15.0002 1.66699H12.5002C11.3951 1.66699 10.3353 2.10598 9.55388 2.88738C8.77248 3.66878 8.3335 4.72859 8.3335 5.83366V8.33366H5.8335V11.667H8.3335V18.3337H11.6668V11.667H14.1668L15.0002 8.33366H11.6668V5.83366C11.6668 5.61264 11.7546 5.40068 11.9109 5.2444C12.0672 5.08812 12.2791 5.00033 12.5002 5.00033H15.0002V1.66699Z"
			strokeLinecap="round"
			strokeLinejoin="round" />
	</svg>
);

export const instagramIcon = (
	<svg
		width="25"
		height="25"
		viewBox="0 0 20 20"
		fill="none"
		aria-hidden="true"
		stroke="currentColor"
	>
		<g clip-path="url(#clip0_3110_20101)">
    <path d="M11.6668 4.33301H11.6735M4.66683 1.33301H11.3335C13.1744 1.33301 14.6668 2.82539 14.6668 4.66634V11.333C14.6668 13.174 13.1744 14.6663 11.3335 14.6663H4.66683C2.82588 14.6663 1.3335 13.174 1.3335 11.333V4.66634C1.3335 2.82539 2.82588 1.33301 4.66683 1.33301ZM10.6668 7.57967C10.7491 8.1345 10.6543 8.70115 10.396 9.19902C10.1377 9.69688 9.72893 10.1006 9.22791 10.3528C8.7269 10.605 8.15913 10.6927 7.60535 10.6036C7.05158 10.5145 6.54 10.2531 6.14339 9.85645C5.74677 9.45983 5.48532 8.94826 5.39621 8.39448C5.3071 7.84071 5.39487 7.27294 5.64705 6.77192C5.89922 6.27091 6.30295 5.86217 6.80082 5.60384C7.29868 5.3455 7.86533 5.25073 8.42016 5.33301C8.98611 5.41693 9.51006 5.68065 9.91462 6.08521C10.3192 6.48977 10.5829 7.01373 10.6668 7.57967Z" stroke="#343941" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_3110_20101">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
	</svg>
);


export const XIcon = (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="currentColor"
		aria-hidden="true"
		stroke="currentColor"
	>
		<path d="M9.20483 8.82224L9.20462 8.822L8.98215 9.13881L3.46206 17H6.70675L10.6472 11.3887L11.0123 10.8687L11.2347 10.5522L16.5379 3H13.2933L9.56998 8.30224L9.20483 8.82224Z"
			strokeLinecap="round"
			strokeLinejoin="round" />
		<path d="M9.20483 8.82224 L3.46206 3  h0.5 L16.5379 17 h-0.5 L3.46206 3" />
	</svg>
);



